<script lang="ts">
  import type { Pathname } from '$app/types'
  import Service from '~/components/business/service.svelte'
  import Container from '~/components/ui/container.svelte'

  const shelfList: { title: string; description: string; icon: string; href?: Pathname }[] = [
    {
      title: 'Desenvolvimento de sistemas sob medida.',
      description:
        'Criar sistemas internos para tomadas de decisão, painéis administrativos de alta performance com automações, implementações de regras complexas e fluxos de trabalhos complexos para operações do seu negócio.',
      icon: 'vaadin:chart-3d',
    },
    {
      title: 'Criação de sites com foco em conversão.',
      description:
        "Com a Lutruvials o preço de um site institucional é acessível e competitivo com seus concorrentes, nosso objetivo claro é gerar vendas e não apenas deixar o site 'existir', com otimização e manutenção mensal.",
      icon: 'solar:server-square-cloud-bold-duotone',
    },
    {
      title: 'Desenvolvimento de E-commerce.',
      description:
        'Abrir a sua loja virtual bem estrutura é complicado, com a Lutruvials a gente foca em uma estrutura robusta, performance e integrações pensando em escalabilidade na necessidade que seu negócio precisa no momento.',
      icon: 'solar:cart-2-line-duotone',
    },
    {
      title: 'Integrações e Automação de processos.',
      description:
        'Deixamos seu CRM, ERP integrado com gateways de pagamentos, software de planejamento e processos com automação de fluxos de trabalhos manuais, e seguros.',
      icon: 'fluent:flash-28-filled',
    },
  ]
</script>

<style>
  .service-list {
    justify-content: center;
  }

  .service-list :global(.service) {
    min-height: 240px;
  }

  .service-list :global(.service__figure) {
    margin-bottom: 8px;

    font-size: 56px;
    line-height: 56px;
  }
</style>

<section class="section | mb-[128px]">
  <Container>
    <h2 class="title | mb-8 text-center text-4xl font-medium lg:text-5xl">
      Criação de sites, Sistemas e Integrações para setores de varejo, lógistica e imobiliário.
    </h2>

    <ul class="service-list | row row-wrap -mx-2 lg:-mx-2">
      {#each shelfList as { icon, title, description, href }}
        <li class="service-item | w-full md:w-2/4 lg:w-1/4">
          <div class="m-2 grow">
            <article>
              <Service {icon} {title} {description} {href} />
            </article>
          </div>
        </li>
      {/each}
    </ul>
  </Container>
</section>
